import React from "react";
// début de modification Kani
import ReactEcharts from "echarts-for-react";
// fin de modification Kani

/*
import {
    XYPlot,
    YAxis,
    HorizontalGridLines,
    AreaSeries,
    LineSeries,
    makeVisFlexible,
  } from "react-vis";
*/

function Graph3Vagues({dataPerso, dataVagues7, dataVagues20, dataVagues50, maximum, dataQ1, dataQ2, dataQ3, GC, print}) {

  // début de modification Kani
  const hauteurFenetre = window.innerHeight;
  const yMax = GC ? 80 : 100;
  const safeData = (data) => (Array.isArray(data) ? data : []);
  const COLOR_COURANT = "#FABE06";
  const COLOR_EXCEPTIONNEL = "#0027CC";
  const COLOR_CATASTROPHIQUE = "#DB04B9";

  const makeLine = (name, data, color, width, dashed) => ({
    name,
    type: "line",
    smooth: false,
    showSymbol: false,
    data: safeData(data).map((p) => [p.x, p.y]),
    lineStyle: { color, width, type: dashed ? "dashed" : "solid" },
    itemStyle: { color },
  });

  const makeArea = (name, data, color) => ({
    name,
    type: "line",
    smooth: true,
    showSymbol: false,
    data: safeData(data).map((p) => [p.x, p.y]),
    lineStyle: { width: 0, color },
    areaStyle: { color, opacity: 1 },
    itemStyle: { color },
    emphasis: { disabled: true },
  });

  const option = {
    animation: false,
    tooltip: { show: false },
    grid: { left: 70, right: 20, top: 20, bottom: 42, containLabel: false },
    xAxis: {
      type: "value",
      min: GC ? 1 : null,
      max: GC ? 520 : null,
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: { show: false },
      axisLabel: {
        show: true,
        color: "#000",
        fontSize: 12,
        margin: 4,
        formatter: (value) => {
          if (GC) {
            if (Math.abs(value - 130) < 5) return "{q1|25% les moins exposées}";
            if (Math.abs(value - 260) < 5) return "{q2|50%}";
            if (Math.abs(value - 390) < 5) return "{q3|25% les plus exposées}";
          }
          return "";
        },
        rich: {
          q1: { padding: [0, 0, 0, 22] },
          q2: {},
          q3: {},
        },
      },
    },
    yAxis: {
      type: "value",
      min: 0,
      max: yMax,
      name: "%PB",
      nameLocation: "middle",
      nameGap: 50,
      nameTextStyle: { color: "#000", fontSize: 14, fontWeight: "bold" },
      splitNumber: 9,
      splitLine: { lineStyle: { color: "#D3D3D3" } },
      axisLabel: { color: "#000", fontSize: 20 },
    },
    series: [
      makeArea("Vagues50", dataVagues50, COLOR_CATASTROPHIQUE),
      makeArea("Vagues20", dataVagues20, COLOR_EXCEPTIONNEL),
      makeArea("Vagues7",  dataVagues7,  COLOR_COURANT),
      makeLine("Q1",    dataQ1,    "black", 4, false),
      makeLine("Q2",    dataQ2,    "black", 4, false),
      makeLine("Q3",    dataQ3,    "black", 4, false),
      makeLine("Perso", dataPerso, "red",   7, true),
    ],
  };

  return (
    <div>
      <ReactEcharts
        option={option}
        style={{
          height: hauteurFenetre < 600 ? "375px" : "450px",
          width: print ? "920px" : "100%",
        }}
      />
    </div>
  );
  // fin de modification Kani

  /*
  const yDomain= GC ? [0,80] : [0,100]
  const xDomain= GC ?[1,520] : ""
  const FlexXYPlot=makeVisFlexible(XYPlot)
  var hauteurFenetre = window.innerHeight;
  return (
    <div>
      <FlexXYPlot height={hauteurFenetre < 600 ? 375 : 450} {...(print ? { width: 920 } : {})} {...{ yDomain}} {...{ xDomain}}>
        <YAxis title="%PB" style={{ text: {stroke: 'none', fill: 'black', fontWeight: 500, fontSize:20} }} tickTotal={9}/>
        <AreaSeries color="#DB04B9" data={dataVagues50} />
        <AreaSeries color="#0027CC" data={dataVagues20} />
        <AreaSeries color="#FFC000" data={dataVagues7} />
        <HorizontalGridLines style={{stroke: '#D3D3D3'}} />
        <LineSeries style={{stroke: 'black', strokeWidth:4, fill:'transparent'}} data={dataQ1} />
        <LineSeries style={{stroke: 'black', strokeWidth:4, fill:'transparent'}} data={dataQ2} />
        <LineSeries style={{stroke: 'black', strokeWidth:4, fill:'transparent'}} data={dataQ3} />
        <LineSeries style={{stroke: 'red', strokeWidth:7, fill:'transparent'}} data={dataPerso} strokeDasharray="8, 4" />
      </FlexXYPlot>
    </div>
  );
  */
}

export default Graph3Vagues;
  